module.exports = __webpack_public_path__ + "img/46c8877.svg";